import React from 'react'
import PropTypes from 'prop-types'

import { eventProptypes } from '../../../utils/propTypes/event'
import { Link } from '@aok/ui-elements'
import { Location } from '@aok/icon-functional'
import { EVENT_ONLINE_TYPE } from '../../../utils/constants/event'

const OfferSearchAddress = ({
  location,
  distance,
  onlineType,
  listView,
  showFullAddress,
  hasMultipleLocations,
  className,
}) => {
  switch (true) {
    case onlineType === EVENT_ONLINE_TYPE.ONLINE:
      return (
        <p className={className}>
          Kurs findet <b>ausschließlich Online</b> statt. Kursbeschreibung enthält weitere Informationen.
        </p>
      )
    case hasMultipleLocations:
      return (
        <div className="flex flex-col">
          <p className="pb-8">
            Der Kurs findet an{' '}
            <Link
              title="mehreren Orten"
              variant="structure"
              onClick={() => {
                const element = document.getElementById('Veranstaltungsort')
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' })
                }
              }}
            />{' '}
            {onlineType === EVENT_ONLINE_TYPE.HYBRID && 'sowie Online '}
            statt.
          </p>
          {distance && <span className="text-293033 font-semibold">Geringste Entfernung:</span>}
          {(location || distance) && (
            <p className={`${className} flex mt-8`}>
              <Location className="relative -bottom-2 mr-8 w-16 h-16 fill-current text-586167 shrink-0" />
              <span>
                {distance && <span>{distance}</span>}
                {distance && location?.address?.street_full && <span> | </span>}
                {location?.address?.street_full && <span>{location?.address?.street_full}, </span>}
                {location?.address?.zip_id && location?.address?.city?.name && (
                  <span>{`${location?.address?.zip_id} ${location?.address?.city?.name}`}</span>
                )}
              </span>
            </p>
          )}
        </div>
      )
    case listView && !!location?.address:
      if (showFullAddress) {
        return (
          <p className={className}>
            {`${
              !!location?.address?.street_full
                ? location?.address?.street_full
                : location?.address?.street?.name + ' ' + location?.address?.number
            }, `}
            <span>{`${location?.address?.zip_id} ${location?.address?.city?.name}`}</span>
          </p>
        )
      } else {
        return <p className={className}>{`${location?.address?.zip_id} ${location?.address?.city?.name}`}</p>
      }
    case !listView && !!location?.address:
      return (
        <p className={`${className} flex`}>
          <Location className="relative -bottom-2 mr-8 w-16 h-16 fill-current text-586167 shrink-0" />
          <span>
            {distance && <span>{distance}</span>}
            {distance && location?.address?.street_full && <span> | </span>}
            {location?.address?.street_full && <span>{location?.address?.street_full}, </span>}
            {location?.address?.zip_id && location?.address?.city?.name && (
              <span>{`${location?.address?.zip_id} ${location?.address?.city?.name}`}</span>
            )}
          </span>
        </p>
      )
    default:
      return null
  }
}

OfferSearchAddress.propTypes = {
  location: eventProptypes.location,
  distance: PropTypes.string,
  onlineType: PropTypes.string,
  listView: PropTypes.bool,
  showFullAddress: PropTypes.bool,
  hasMultipleLocations: PropTypes.bool,
  className: PropTypes.string,
}

OfferSearchAddress.defaultProps = {
  onlineType: '',
  listView: false,
  showFullAddress: false,
  hasMultipleLocations: false,
  className: '',
}

export default OfferSearchAddress
